var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLoading = function SvgLoading(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95 50C97.7614 50 100.026 52.2442 99.7502 54.9918C98.935 63.1172 96.1385 70.9465 91.5735 77.7785C86.0794 86.001 78.2705 92.4096 69.1342 96.194C59.9979 99.9784 49.9445 100.969 40.2455 99.0393C30.5464 97.11 21.6373 92.348 14.6447 85.3553C7.65204 78.3627 2.89 69.4536 0.960736 59.7545C-0.968525 50.0555 0.0216418 40.0021 3.80602 30.8658C7.59041 21.7295 13.999 13.9206 22.2215 8.42652C29.0535 3.86151 36.8828 1.06502 45.0082 0.249773C47.7558 -0.0259071 50 2.23858 50 5V5C50 7.76142 47.7528 9.96779 45.0129 10.3121C38.8688 11.0841 32.9638 13.2757 27.7772 16.7412C21.1992 21.1365 16.0723 27.3836 13.0448 34.6927C10.0173 42.0017 9.22518 50.0444 10.7686 57.8036C12.312 65.5629 16.1216 72.6902 21.7157 78.2843C27.3098 83.8784 34.4371 87.688 42.1964 89.2314C49.9556 90.7748 57.9983 89.9827 65.3073 86.9552C72.6164 83.9277 78.8635 78.8008 83.2588 72.2228C86.7243 67.0362 88.9159 61.1312 89.6879 54.9871C90.0322 52.2472 92.2386 50 95 50V50Z",
    fill: "#0486FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoading, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loading.26150c52.svg";
export { ForwardRef as ReactComponent };